import type { ColumnPlugin, ColumnPluginContext } from "app/pages/sales-intelligence/common-components/column-picker";
import { UpgradeColumnButton } from "app/pages/sales-intelligence/common-components/column-picker/components/UpgradeColumnButton";
import { SdkFeatureUpgradeBanner } from "app/pages/sales-intelligence/common-components/feature-upgrade";

import type { SdkUpgradePluginConfig, TechnologyColumnPickerPlugins } from "./types";

const SDK_UPGRADE_PLUGIN = "sdkUpgrade" as const;

/**
 * Technology-related plugins for column picker.
 */
export const technologyColumnPickerPlugins: TechnologyColumnPickerPlugins = {
    createSdkUpgradeButton: (config: SdkUpgradePluginConfig): ColumnPlugin => ({
        id: SDK_UPGRADE_PLUGIN,
        slot: "column-action",
        behavior: "substitute",
        shouldRender: (context: ColumnPluginContext) =>
            context.column.upgradePlugin === SDK_UPGRADE_PLUGIN,
        render: () => ({
            priority: 1,
            component: (
                <UpgradeColumnButton
                    tooltipContent={
                        <SdkFeatureUpgradeBanner
                            hasHeader
                            isSubmitted={config.isHookSubmitted}
                            onSubmit={config.onHookSubmit}
                        />
                    }
                />
            ),
        }),
    }),
};
